import React from "react";
import "./header.css";
import RightSideModal from "../../../newComponents/Modal/right-side-modal";
import SingleChatMessages from "../../../newComponents/SingleChatBox/SingleChatmessages";
import OrganizationNameHeader from "../../../components/common/OrganizationNameHeader/OrganizationNameHeader";
import { useTheme } from "../../../utils/context/ThemeContext";
import { Moon, Sun } from "lucide-react";

interface TenantHeaderProps {
  chatIconSrc: string;
  onChatClick?: () => void;
  tenantId?: number;
  isChatOpen?: boolean;
  OrgDetail?: any;
  unreadCount?: number;
}

const TenantHeader: React.FC<TenantHeaderProps> = ({
  chatIconSrc,
  onChatClick,
  tenantId,
  isChatOpen,
  OrgDetail,
  unreadCount,
}) => {
  const { theme, toggleTheme } = useTheme();
  return (
    <>
      <RightSideModal
        isOpen={isChatOpen}
        onClose={onChatClick}
        title="Message"
        maxWidth={550}
        isFooterHidden={true}
      >
        {/* Mount only while open: fetching the message list marks messages
            read server-side, so a closed (CSS-hidden) chat must not fetch */}
        {isChatOpen && (
          <SingleChatMessages
            isHeader={false}
            tenantId={tenantId}
            tenantHeaderChatHeight="tenantHeaderChatHeight"
            skipTenantOrgLookup={true}
          />
        )}
      </RightSideModal>
      <header className="tenant-header">
        <OrganizationNameHeader
          OrgName={OrgDetail?.name}
          OrgImg={
            OrgDetail?.logoImageBase64 !== ""
              ? `data:image/*;base64,${OrgDetail?.logoImageBase64}`
              : null
          }
          SubHeaderName={""}
          element={
            <>
              <div className="onboardtopbar__right d-flex align-items-center gap-2">
                <button
                  onClick={toggleTheme}
                  className="onboardtopbar__chat-btn"
                  title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                >
                  {theme === "light" ? <Moon size={20} color="#667085" /> : <Sun size={20} color="#f9fafb" />}
                </button>
                <div style={{ position: "relative", display: "inline-flex" }}>
                  <button
                    onClick={onChatClick}
                    className="onboardtopbar__chat-btn"
                  >
                    <img src={chatIconSrc} alt="Chat Icon" className="color-white-icon" />
                  </button>
                  {(unreadCount ?? 0) > 0 && (
                    <span className="chat-unread-badge">{unreadCount}</span>
                  )}
                </div>
              </div>
            </>
          }
        />
      </header>
    </>
  );
};

export default TenantHeader;
